import React, { useEffect, useState } from "react";
import { Button } from "antd";
import ResponsiveTable from "../design-system/ResponsiveTable";
import { itemRender, onShowSizeChange } from "../commons/PaginationFunction";
import { Error } from "../commons/Messages/Messages";
import axios from "axios";
import BreadCrump from "../commons/BreadCrump/BreadCrump";
import moment from "moment";
import "./Meetings.css";

import { useTranslation } from "react-i18next";
import { openExternal } from "../native/files";
const ClientMeetings = () => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/meetings`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          setData(res.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        if (err?.response && err?.response?.data && err?.response?.data?.errors) {
          const validationErrors = err?.response?.data?.errors;
          const errorMessage = Object.values(validationErrors)
            ?.map(err => `${err?.path} is ${err?.kind}.`)
            .join("\n");
          Error(errorMessage);
        } else if (err?.response?.data?.keyPattern) {
          Error(Object.keys(err?.response?.data?.keyPattern) + " already exists");
        } else {
          Error(err.message);
        }
      });
  };

  const joinMeeting = async e => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/meetings/join`,
        {
          ss: ""
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          openExternal(res.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a._id.length - b._id.length
    },
    {
      title: t("Meeting ID"),
      dataIndex: "meetingID",
      sorter: (a, b) => a.meetingID.localeCompare(b.meetingID)
    },
    {
      title: t("Meeting Name"),
      dataIndex: "meetingName",
      mobile: "title",
      sorter: (a, b) => a.meetingName.localeCompare(b.meetingName)
    },
    {
      title: t("Created Date"),
      dataIndex: "createdAt",
      render: text => moment(text).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t("Action"),
      key: "action",
      dataIndex: "",
      render: () => (
        <Button type="primary" onClick={joinMeeting}>
          {t("Join Meeting")}
        </Button>
      ),
      sorter: (a, b) => a.length - b.length
    }
  ];

  return (
    <div className="client-meetings">
      <h3 className="client-meetings__title">{t("Join Meetings")}</h3>
      <ResponsiveTable
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey={record => record.id}
      />
    </div>
  );
};

export default ClientMeetings;
